import EditHomepage from "./EditHomepage"

export default EditHomepage
